// Projects data.
// Note: Here we are getting data from a js file, but in a different project I'll be fetching these projects from some srt of APIs.

const projects = [
	{
		id: 1,
		title: '占位剧情游戏',
		category: '占位游戏简介',
		img: require('@/assets/images/game-project-placeholder.png'),
	},
	{
		id: 2,
		title: '占位创意游戏',
		category: '占位游戏简介',
		img: require('@/assets/images/game-project-placeholder.png'),
	},
	{
		id: 3,
		title: '占位美术游戏',
		category: '占位游戏简介',
		img: require('@/assets/images/game-project-placeholder.png'),
	},
	{
		id: 4,
		title: '占位关卡设计',
		category: '占位游戏简介',
		img: require('@/assets/images/game-project-placeholder.png'),
	},
	{
		id: 5,
		title: '占位配乐游戏',
		category: '占位游戏简介',
		img: require('@/assets/images/game-project-placeholder.png'),
	},
	{
		id: 6,
		title: '占位其他游戏1',
		category: '占位游戏简介',
		img: require('@/assets/images/game-project-placeholder.png'),
	},
	{
		id: 7,
		title: '占位其他游戏2',
		category: '占位游戏简介',
		img: require('@/assets/images/game-project-placeholder.png'),
	},
	{
		id: 8,
		title: '占位其他游戏3',
		category: '占位游戏简介',
		img: require('@/assets/images/game-project-placeholder.png'),
	},
	// {
	// 	id: 9,
	// 	title: '占位其他',
	// 	category: '占位游戏简介',
	// 	img: require('@/assets/images/game-project-placeholder.png'),
	// },

];

export default projects;
